/** WEBCHAT */
import useStore from './useStore'
import { setCurrentComponent } from '@/store'
import useIframeControl from '@/hooks/iframe'

export interface Navigation {
  next(): void;
  back(): void;
  start(): void;
  setErrorState(): void;
  setSuccessState(): void;
  tryAgain(): void;
}

export default function useNavigation (): Navigation {
  const store = useStore()

  function setErrorState (): void {
    setCurrentComponent('SteepError')
  }

  function setSuccessState (): void {
    setCurrentComponent('SteepSuccess')
  }

  function next (): void {
    if (store.currentComponent === 'SelectStart') {
      setCurrentComponent('SelectChat')

      const iframe = useIframeControl()
      iframe.notifyOpen()
    }
  }

  function back (): void {
    // 'SelectStart'
    setCurrentComponent(store.previusComponent)
  }

  function start (): void {
    setCurrentComponent('SelectStart')
  }

  function tryAgain (): void {
    if (store.channel === 0) {
      document.location.reload()
      return
    }

    if (store.email === '') {
      setCurrentComponent('SelectStart')
      return
    }

    back()
  }

  return { next, back, start, setErrorState, setSuccessState, tryAgain }
}
